/**
 * Verify if the item has some permission.
 * 
 * @param {(Array<any>|null)} itemGroups 
 * @param {(string|number)} permissionRequired 
 * @param {(string|null)} createdBy 
 * @param {boolean} skipGroups 
 * 
 * @return {boolean} Boolean
 */
const verifyItemPermission = (
  itemGroups: Array<any>|null, 
  permissionRequired: string|number, 
  createdBy: string|null, 
  skipGroups: boolean = false
): boolean => {
  const userId = localStorage.getItem('userId')
  const userPermissions: Array<Object> = JSON.parse(localStorage.getItem('userPermissions'))
  const defaultPermissions: Array<Object> = JSON.parse(localStorage.getItem('defaultPermissions'))

  if (!userPermissions || !defaultPermissions) return false
  if (userPermissions.find((up: any) => up.alias === 'admin')) return true
  if (!itemGroups && !skipGroups) return false
  let groups = itemGroups && !Array.isArray(itemGroups) ? Object.keys(itemGroups) : itemGroups
  groups = groups && Array.isArray(groups) ? groups.map((g: any) => Number(g)).filter((g: any) => !isNaN(g)) : []
  const permission: number = typeof permissionRequired === 'string' ? defaultPermissions.find(r => r.name === permissionRequired).id : permissionRequired
  const totalPermissions = userPermissions.map((up: any) => {
    const hasPermission = up.permissions.find((r: any) => {
      const hasGroup = skipGroups ? true : groups.includes(r.target_group_id)
      const isPermissionId = r.group_permission_id === permission
      const isAllowed = () => {
        if (![1, 2].includes(r.rule)) return false
        if (r.rule === 1) return true
        if (r.rule === 2 && skipGroups) return true

        return r.rule === 2 && userId === createdBy
      }
      return hasGroup && isPermissionId && isAllowed()
    })

    return hasPermission ? true : false
  })
  return totalPermissions.find(r => r) || false
}

export default verifyItemPermission